import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { alertsApi } from '../../api/lib/alerts';
import { alertsKeys } from '../../api/query-keys/alerts';
import { Alert } from '../../api/types/alert';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useAlerts = ({ page, perPage }: { page: number; perPage: number }) => {
  return useQuery<PaginatedResponse<Alert>, ApiError>({
    queryKey: alertsKeys.list(page, perPage),
    queryFn: () => alertsApi.fetchAlerts(page, perPage),
  });
};
